<template>
    <center class="login-center">
        <div class="login-form">
            <div class="head">
            <h1>Register</h1>
            <!-- <p>Welcome to the future of savings & investments</p> -->
            </div>
            <form @submit.prevent="handleSubmit">
                <p>
                    <label>Full Name</label><br />
                    <input type="text" v-model="name" placeholder="Enter Full Name" required>
                </p>

                <p>
                    <label>Email Address</label><br />
                    <input type="text" v-model="email" placeholder="Enter Email Address" required>
                </p>

                <p>
                    <label>Password</label><br />
                    <input type="password" v-model="password" placeholder="Enter Password" required/>
                </p>

                <p>
                    <button type="submit" >
                        Create Account
                    </button>
                </p>
            </form>
        </div>
       <router-link to="/login" class="login_link"><p class="login">Already have an account? Login</p></router-link>
    </center>
</template>

<script>
import axios from 'axios'
export default {
    name: 'RegisterPage',
    data() {
        return {
            name: '',
            email: '',
            password: '',
        };
    },
    methods: {
        async handleSubmit() {
            const root_api_url = process.env.VUE_APP_API_ROOT_URL;

            let result = await axios.post(root_api_url+'/auth/register',{
                    name: this.name,
                    email: this.email,
                    password: this.password
            });

            console.warn(result);
            if(result.status == 201){
                alert("Registration Successful");
                this.$router.push({name: 'Login'});
            }
        }
    }
}


</script>

<style scoped>
.error-message {
  color: red;
  font-size: 12px;
}
</style>
